import { render } from "./FAQ_page.vue?vue&type=template&id=04b427ca"
import script from "./FAQ_page.vue?vue&type=script&lang=js"
export * from "./FAQ_page.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__